import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';

import useUser from 'hooks/useUser';

import { getDashboardRedirectPath } from 'modules/auth/Auth.utils';
import { LoadingLogo } from 'shared/components/Modal/LoadingLogo';
import useFeatureFlags from 'hooks/useFeatureFlags';
import { FlagKey } from '../api/types';

export function DashboardGuard() {
  const { userResult, selectedAgreement } = useUser();
  const location = useLocation();
  const {
    flags: { [FlagKey.onboardingRefresh]: onboardingRefresh },
  } = useFeatureFlags();

  if (userResult?.loading) return <LoadingLogo />;

  const { hasDashboardAccess, redirectPath } = getDashboardRedirectPath(
    userResult?.user || undefined,
    selectedAgreement,
    onboardingRefresh,
  );

  if (!hasDashboardAccess) {
    return <Navigate to={redirectPath} replace state={{ path: location.pathname }} />;
  }

  return <Outlet />;
}

export default DashboardGuard;
